<template>
  <div class="not-found-page">
    <v-container class="not-found-content">
      <p class="not-found-code">404</p>
      <h1>Page not found</h1>
      <p>The address may be incorrect, or the page may have moved.</p>
      <v-btn color="error" large :to="{ name: 'home' }">
        Return home
      </v-btn>
    </v-container>
    <AppFooter />
  </div>
</template>

<script>
import AppFooter from '../components/Footer.vue';

export default {
  name: 'NotFoundView',
  components: { AppFooter },
};
</script>

<style scoped>
.not-found-page {
  background: #050505;
  color: #fff;
  min-height: 100vh;
}

.not-found-content {
  min-height: 70vh;
  padding-bottom: 96px;
  padding-top: 120px;
  text-align: center;
}

.not-found-code {
  color: #e23232;
  font-family: "Oswald", sans-serif;
  font-size: 1rem;
  font-weight: 900;
  letter-spacing: 0.12em;
  margin-bottom: 12px;
}

h1 {
  font-family: "Oswald", sans-serif;
  font-size: clamp(2.8rem, 8vw, 5.5rem);
  line-height: 1;
  margin-bottom: 20px;
}

.not-found-content > p:not(.not-found-code) {
  color: #bdbdbd;
  font-size: 1.15rem;
  margin: 0 auto 32px;
  max-width: 520px;
}
</style>
